import { ListingOfferCardHorizontal } from 'app/components/listing-card-horizontal.large';
import type { ListingOfferCardProps } from 'app/types/listing-offer-card-props';
import { useUser } from 'app/network/user';

export function ManagementOfferCard(props: ListingOfferCardProps) {
  const { data: user } = useUser();
  const isGuardian = props.listing.guardianId === user?.id && props.listing.userId !== user?.id;
  return (
    <ListingOfferCardHorizontal
      {...props}
      horizontalVariant="management"
      {...(isGuardian
        ? {
            onDelete: undefined,
            onHide: undefined,
            onUnhide: undefined,
            onBlockDates: undefined,
            onChangeLoanFee: undefined,
          }
        : {})}
    />
  );
}
